import { type Encargado, type EncargadoRequest } from '../types/encargado';
import { http } from '../../../../api/http';

export class EncargadoService {
  private static readonly ENDPOINTS = {
    LIST: '/Catalog/encargados',
    CREATE: '/Catalog/encargados',
    UPDATE: '/Catalog/encargados',
    DELETE: '/Catalog/encargados',
  };

  public static async getEncargados(): Promise<Encargado[]> {
    try {
      const response = await http.get(this.ENDPOINTS.LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching encargados:', error);
      throw error;
    }
  }

  public static async saveEncargado(encargadoRequest: EncargadoRequest): Promise<Encargado> {
    try {
      const isUpdate = !!encargadoRequest.id;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} encargado:`, {
        url: this.ENDPOINTS.CREATE,
        method: 'POST',
        isUpdate,
        data: encargadoRequest
      });

      const response = await http.post(this.ENDPOINTS.CREATE, encargadoRequest);

      console.log(`Encargado ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${encargadoRequest.id ? 'updating' : 'creating'} encargado:`, error);
      throw error;
    }
  }

  public static async deleteEncargado(id: number): Promise<void> {
    try {
      console.log('Deleting encargado:', { id, url: `${this.ENDPOINTS.DELETE}/${id}` });

      await http.delete(`${this.ENDPOINTS.DELETE}/${id}`);

      console.log('Encargado deleted successfully:', id);
    } catch (error) {
      console.error('Error deleting encargado:', error);
      throw error;
    }
  }
}
